import "core-js/features/array/fill";
import "core-js/features/promise";
import "core-js/features/url-search-params";
import "core-js/features/object/assign";
import "core-js/features/object/keys";
import "core-js/features/string/starts-with";
import "stylesheets/application";

window.$ = window.jQuery = require("jquery");
require("jquery-ujs");
window.R = require("ramda");
// window.angular = require("angular");
import "angular";

require("angular-recaptcha");

require("angular-growl-v2");
require("angular-growl-v2/build/angular-growl.css");

require("../common/common");
require("packs/ticketbuyer_entity");
require("../common/behaviors/index");
require("../common/libs/section/index");

require("../common/initializeZendeskWidget");
require("../ticketbuyer/google_anlytics/ga_cookie");
require("../ticketbuyer/common/queue-it");
require("../ticketbuyer/common/share");
require("../ticketbuyer/common/ticketbuyer_seating_section");
require("../ticketbuyer/legal_terms");
require("../ticketbuyer/retrieve_items");
require("../ticketbuyer/click_cards");
require("../ticketbuyer/entities");
require("../ticketbuyer/territory_language_dropdown");

require("../common/notifications");
require("../common/security_reports");
require("../common/calendar");
require("../common/videojs/initialize");
require("../admin/stream_health");
require("../admin/behaviors/copyToClipboard");
require("../admin/subscription");

import "../ticketbuyer/ticketbuyer_profile_dropdown";
import "../common/pooling";
import "../common/notification";
import "../home_events_search";
import "../analytics_async";
import "../admin/page_config";
import "../common/section";
import "../common/arena";
import "../common/cable";
import "common/mailgun";
import "../common/libs/bootstrap";
import "../admin/initialize_components";
